import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import SignatureParam from './SignatureParam';
import Markdown from './Markdown';
import './Signature.css';

const Signature = ({ signature, link }) => (
    <div className="signature">
        <NavLink to={link} className="signature-name">{signature.name}</NavLink>
        <div className="signature-info">
            {signature.deprecated &&
                <div className="signature-depreacted-msg">
                    Deprecated in {signature.deprecatedVersion}. {signature.deprecatedInfo}
                </div>
            }

            <div className="signature-introduced">
                <Markdown text={signature.introduced} />
            </div>

            <div className="signature-description">
                <Markdown text={signature.description} />
            </div>

            <div className="signature-nohyperlink">
                <Markdown text={signature.hyperlinkDisabled} />
            </div>

            <div className="signature-workflow">
                <Markdown text={signature.workflowReqs} />
            </div>

            {signature.parameters.length > 0 &&
                <div><strong>Parameters:</strong></div>
            }

            {signature.parameters.map(param => (
                <SignatureParam key={param.name} param={param} />
            ))}
        </div>
    </div>
);

Signature.propTypes = {
    link: PropTypes.string.isRequired,
    signature: PropTypes.object.isRequired
}

export default Signature;


// WEBPACK FOOTER //
// ./src/Signature.js